<div class="height100p flex-col">
  @if (editingAllowed === false) {
    <p-card class="flex-item-fixed mb-2" header="Bearbeitung nicht freigegeben">
      <span style="color: red">Die Bearbeitung der Zeugnisse wurde durch den Administrator noch nicht freigegeben.</span>
    </p-card>
  }
  @if (editingAllowed && inited) {
    <sm-toolbar class="flex-item-fixed">
      @if (!isPast && bufferedIsChanged) {
        <button pButton icon="fas fa-save" label="Speichern" (click)="save()">
        </button>
      }
      <button pButton icon="fas fa-save" label="Klassenspiegel exportieren" (click)="export()">
      </button>
      @if (supportsSemester) {
        <span class="ml-3">{{enaioSchoolClass.grade == 12 ? 'Semester: ' : 'Halbjahr: '}}</span>
        <p-select class="width200" id="semester" [options]="semesterOptions" [(ngModel)]="selectedSemester" (ngModelChange)="gradeUpdated()"></p-select>
      }
      @if (bufferedIsChanged) {
        <p-message severity="warn">WICHTIG: Alle vorgenommen Änderungen werden erst beim Betätigen des Speichern-Buttons dauerhaft übernommen</p-message>
      }
    </sm-toolbar>
    <sm-tab-view class="flex-item-fill full-height">
      <sm-tab header="Klassenübersicht">
        <sm-table class="height100p" [data]="overviewTable" [useTableMenu]=false [useColumnMenu]=false [headerHeight]=150></sm-table>
      </sm-tab>
      <sm-tab header="Fachnoten">
        <div class="height100p flex-col-fixed-fill">
          <sm-toolbar>
            <p-select class="width300" id="domain" [options]="domains" [(ngModel)]="selectedDomain" (ngModelChange)="updatePupilsTable()"></p-select>
            <button pButton icon="fas fa-eye" label="Leistungsarten anzeigen" (click)="showExamTypes($event)">
            </button>
            <button pButton icon="fas fa-plus" (click)="addExam($event)"></button>
            <p-checkbox appLabel="Übersetzung anzeigen" name="showTranslation" [(ngModel)]="showTranslation" [binary]=true (ngModelChange)="updatePupilsTable()"></p-checkbox>
          </sm-toolbar>
          <sm-table [data]="pupilsTable" [useTableMenu]=false [useColumnMenu]=false [tabForSameCol]=true [headerHeight]=80 [horizontalScroll]=true (onCellEditingStopped)="gradeUpdated()">
          </sm-table>
        </div>
      </sm-tab>
      @if (useHeadNotes) {
        <sm-tab header="Kopfnoten">
          <p-table class="p-datatable-gridlines" [value]="pupils" sortField="lastName" (onEditComplete)="gradeUpdated()">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 50px">#</th>
                <th [pSortableColumn]="'lastName'">Nachname<p-sortIcon [field]="'lastName'"></p-sortIcon></th>
                <th  [pSortableColumn]="'firstName'">Vorname<p-sortIcon [field]="'firstName'"></p-sortIcon></th>
                @for (grade of conductCompetencies; track grade) {
                  <th style="height:250px; width: 50px"><span style="writing-mode: vertical-rl; height: 100%">{{grade.title}}</span></th>
                }
                <th class="primary-color" colspan=2 style="width: 200px">&Oslash;</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pupil let-index="rowIndex">
              <tr [pSelectableRow]="pupil">
                <td>{{index + 1}}</td>
                <td>{{pupil.lastName}}</td>
                <td>{{pupil.firstName}}</td>
                @for (grade of conductCompetencies; track grade) {
                  <td pEditableColumn class="mouse-pointer">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <sm-grade-editor [value]="conductGradeMap[pupil.id.toString() + '|' + grade.id.toString()]"  [gradeType]="gradeSettings.gradeType"></sm-grade-editor>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{formatValue(conductGradeMap[pupil.id.toString() + '|' + grade.id.toString()].grade, _NumberFormatMode.decimalZero)}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                }
                <td class="primary-color" style="width: 50px">{{formatValue(averageMap[pupil.id + "|conduct"])}}</td>
                <td class="primary-color" style="width: 150px">{{formatTextualGrade(averageMap[pupil.id + "|conduct"])}}</td>
              </tr>
            </ng-template>
          </p-table>
        </sm-tab>
      }
      <sm-tab header="Historie">
        <sm-table class="height100p" [data]="historyTable"></sm-table>
      </sm-tab>
    </sm-tab-view>
  }
</div>
<p-popover #opExamTypeFactors>
  <ng-template pTemplate>
    <sm-table class="width300" [autoHeight]=true [data]="examTypeFactorsTable"></sm-table>
  </ng-template>
</p-popover>



